import React, { useEffect } from "react";
import {
  Box,
  Container,
  Paper,
  Typography,
  CircularProgress,
  LinearProgress,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import SecurityIcon from "@mui/icons-material/Security";
import PaymentIcon from "@mui/icons-material/Payment";
import { useDispatch, useSelector } from "react-redux";
import CryptoJS from "crypto-js";
import { instantBookingTokenGeneratorRequest } from "../../redux/Bookings/BookingAction";
import { insertOrderRequest } from "../../redux/Payments/paymentActions";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  PAYMENT_FAILURE,
  PAYMENT_SUCCESS,
} from "../../component/common/Routes/AppRoutes";

const PaymentProcessingPage = () => {
  const user = useSelector((state) => state.auth.user);
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const customerId = queryParams.get("customer_id");
  const orderId = queryParams.get("pnr_no");
  const booking = useSelector((state) => state?.booking);
  const editBookingDetail = useSelector((state) => state.booking?.editBooking);
  const token = booking?.instantBooking?.data;
  const dispatch = useDispatch();
  const paymentUrl =
    booking?.data?.payment_url || editBookingDetail?.data?.paymentUrl;
  const orderData = useSelector((state) => state?.Payment?.order?.data);
  const navigate = useNavigate();
  const orderStatus = orderData?.order_status;

  useEffect(() => {
    if (orderId) {
      dispatch(insertOrderRequest(orderId));
    }
  }, [orderId]);

  useEffect(() => {
    if (orderId === orderData?.pnr_number)
      setTimeout(() => {
        if (orderStatus === 1) {
          navigate(PAYMENT_SUCCESS, {
            state: { orderData: orderData, paymentUrl: paymentUrl },
          });
        } else {
          navigate(PAYMENT_FAILURE, {
            state: { orderData: orderData, paymentUrl: paymentUrl },
          });
        }
      }, 5000);
  }, [orderStatus, orderData?.pnr_number]);
  useEffect(() => {
    if (!user) {
      dispatch(instantBookingTokenGeneratorRequest(customerId));
    }
  }, []);

  const SECRET_KEY = "843567893696976453275974432697R634976";
  useEffect(() => {
    if (token) {
      const encryptedAccessToken = CryptoJS.AES.encrypt(
        token,
        SECRET_KEY
      ).toString();

      localStorage.setItem("instantToken", encryptedAccessToken);
    }
  }, [token]);

  return (
    <Container
      maxWidth="sm"
      sx={{ display: "flex", minHeight: "100vh", alignItems: "center" }}
    >
      <Paper
        elevation={3}
        sx={{
          width: "100%",
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", mb: 4 }}>
          <LockIcon color="primary" sx={{ fontSize: 28, mr: 1 }} />
          <Typography variant="h4" component="h1">
            Payment Processing
          </Typography>
        </Box>
        <CircularProgress size={70} thickness={4} sx={{ mb: 4 }} />
        <Typography
          variant="h5"
          fontWeight="medium"
          color="primary"
          gutterBottom
        >
          Please Wait Patiently
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 4, maxWidth: 400 }}
        >
          Your payment is being processed. This may take a few moments to
          complete.
        </Typography>
        <Box sx={{ width: "100%", mb: 3 }}>
          <LinearProgress sx={{ height: 8, borderRadius: 4 }} />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 4,
          }}
        >
          <PaymentIcon
            fontSize="small"
            sx={{ mr: 1, color: "text.secondary" }}
          />
          <Typography
            variant="body2"
            color="text.secondary"
            fontWeight="medium"
          >
            Please do not refresh or close this window
          </Typography>
        </Box>
        <Box
          sx={{
            mt: 2,
            pt: 3,
            borderTop: 1,
            borderColor: "divider",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <SecurityIcon
            fontSize="small"
            sx={{ mr: 1, color: "text.secondary" }}
          />
          <Typography variant="caption" color="text.secondary">
            Your transaction is secure and encrypted
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};
export default PaymentProcessingPage;
